"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pinRenderer = void 0;
var React = require("react");
var classnames_1 = require("classnames");
var myokay_map3_1 = require("@okay/myokay-map3");
var format_1 = require("@/utils/format");
var searchResponseToResultPage_1 = require("@/transformers/searchResponseToResultPage");
var propertyToUrl_1 = require("@/transformers/propertyToUrl");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
exports.pinRenderer = function (props) { return function (map, pin) {
    var popTop = false;
    var popRight = false;
    var popBottom = false;
    var popLeft = false;
    var sw = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
    var ne = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
    var me = map.getProjection().fromLatLngToPoint(new google.maps.LatLng(pin.lat, pin.lng));
    var leftGap = (me.x - sw.x) / (ne.x - sw.x);
    var topGap = (me.y - ne.y) / (sw.y - ne.y);
    var rightGap = (ne.x - me.x) / (ne.x - sw.x);
    var bottomGap = (sw.y - me.y) / (sw.y - ne.y);
    if (leftGap < 0.25)
        popRight = true;
    if (rightGap < 0.25)
        popLeft = true;
    if (topGap < 0.40)
        popBottom = true;
    if (bottomGap < 0.25)
        popTop = true;
    var onClick = function (e) {
        e.stopPropagation();
        if (pin.type === myokay_map3_1.PinTypes.BUBBLE) {
            return props.zoomInPin(pin);
        }
        props.setPinActive(pin);
    };
    var onClose = function (e) {
        e.stopPropagation();
        props.setPinInactive(pin);
    };
    var renderPopup = function () {
        var properties = [];
        if (pin.isCluster) {
            pin.value
                .map(function (it) { return it.value.properties; })
                .reduce(function (acc, it) { return acc.concat(it); }, [])
                .map(function (it) { return properties.push(it); });
        }
        else {
            pin.value.properties
                .map(function (it) { return properties.push(it); });
        }
        if (!properties.length)
            return null;
        var mappopclass = classnames_1.default('c-mappop', {
            'c-mappop--right': popRight,
            'c-mappop--left': popLeft,
            'c-mappop--top': popTop,
            'c-mappop--bottom': popBottom,
            'c-mappop--taller': properties.length > 2,
        });
        var renderItem = function (item, index) {
            if (!item)
                return null;
            var favIds = props.favIds || [];
            var propertyPhotoes = [];
            if (item.propertyPhoto ||
                item.propertyPhoto === '') {
                propertyPhotoes = searchResponseToResultPage_1.photoStrToPhotos(item.propertyPhoto, item.id);
            }
            else {
                propertyPhotoes = item.propertyPhotos;
            }
            var images = [];
            var size = 0;
            images = propertyPhotoes.map(function (it) { return ({
                path: "" + searchResponseToResultPage_1.toPhotoPath(it.photoName, it.photoType, props.imgDomain, size),
                caption: searchResponseToResultPage_1.photoTypeMap[it.photoType.toUpperCase()],
            }); });
            var url = '';
            url = propertyToUrl_1.propertyToUrl(props.lang, item.buildingName, item.id, SfilterTypeGroup_1.ListingPurposeType.toSfilterType(item.listingTypeId));
            var renderImage = function () {
                return images.length ? (React.createElement("div", { className: "c-mappop__pic" },
                    React.createElement("img", { src: images.length ? images[0].path : '', alt: "" }))) : React.createElement("div", { className: "c-mappop__pic c-mappop__pic--nopic" });
            };
            var favBtnClass = classnames_1.default('c-mappop__btn', {
                'c-mappop__btn--active': favIds.indexOf(item.id) >= 0,
            });
            var toggleFav = function () { return props.toggleFav(item.id); };
            var renderPrice = function (item, symbol, t) {
                if (item.isSaleSTO || item.isLeaseSTO) {
                    return t.subjectToOffer;
                }
                return format_1.default.currency(item.salePrice ? item.salePrice : item.leasePrice * 1000, symbol);
            };
            return (React.createElement("div", { key: index, className: "c-mappop__item" },
                renderImage(),
                React.createElement("div", { className: "c-mappop__info" },
                    React.createElement("a", { href: url, className: "c-mappop__title" }, item.buildingName),
                    React.createElement("div", { className: "c-mappop__main" },
                        React.createElement("div", { className: "c-mappop__body" },
                            React.createElement("div", { className: "c-mappop__price" }, renderPrice(item, props.symbol, props.results.t)),
                            React.createElement("div", { className: "c-mappop__details" },
                                React.createElement("div", { className: "c-mappop__detail" },
                                    React.createElement("div", { className: "c-mappop__value" }, item.netSize ? item.netSize : item.grossSize),
                                    React.createElement("div", { className: "c-mappop__unit" },
                                        props.results.t.sqft,
                                        " (",
                                        item.netSize ? props.results.t.saleable : props.results.t.gross,
                                        ")")),
                                React.createElement("div", { className: "c-mappop__detail" },
                                    React.createElement("div", { className: "c-mappop__value" }, item.bedrooms),
                                    React.createElement("div", { className: "c-mappop__unit" }, props.results.t.bd)),
                                React.createElement("div", { className: "c-mappop__detail" },
                                    React.createElement("div", { className: "c-mappop__value" }, item.bathrooms),
                                    React.createElement("div", { className: "c-mappop__unit" }, props.results.t.ba)))),
                        React.createElement("div", { className: "c-mappop__side" },
                            React.createElement("button", { onClick: toggleFav, className: favBtnClass }))))));
        };
        return (React.createElement("div", { className: mappopclass },
            React.createElement("div", { onClick: onClose, className: "c-mappop__close" },
                React.createElement("span", { className: "fal fa-times" })),
            React.createElement("div", { className: "c-mappop__head" },
                React.createElement("div", { className: "c-mappop__header" },
                    properties.length,
                    ' ',
                    properties.length > 1 ? props.results.t.units : props.results.t.unit)),
            React.createElement("div", { className: "c-mappop__items" }, properties.map(renderItem))));
    };
    if (pin.type === 1 || pin.type === 2) {
        var clusterClass_1 = classnames_1.default('c-mapcluster', 'c-mapcluster--nooffset', {
            'c-mapcluster--dark': pin.count > 1 && pin.count <= 5,
            'c-mapcluster--mid': pin.count > 5,
            'c-mapcluster--darker': pin.count > 5,
            'c-mapcluster--bg': pin.unfocus,
            'c-mapcluster--leg': pin.type === 2,
        });
        return (React.createElement("div", { onClick: onClick, className: clusterClass_1, style: { cursor: pin.type === 2 ? 'pointer ' : 'default' } },
            React.createElement("span", { className: "c-mapcluster__value" }, format_1.default.comma(pin.count)),
            pin.popupActive ? renderPopup() : null));
    }
    if (pin.type === 3) {
        var clusterClass_2 = classnames_1.default('c-maplabel', 'c-maplabel--nooffset', {
            'c-maplabel--highlight': pin.noCluster,
            'c-maplabel--bg': pin.unfocus,
        });
        var minPrice = pin.isCluster ? Math.min.apply(Math, pin.value.map(function (it) { return it.value.minPrice; })) : pin.value.minPrice;
        var maxPrice = pin.isCluster ? Math.max.apply(Math, pin.value.map(function (it) { return it.value.maxPrice; })) : pin.value.maxPrice;
        var title = minPrice === maxPrice ? "" + format_1.default.currency(minPrice, props.symbol) : format_1.default.currency(minPrice, props.symbol) + "-" + format_1.default.currency(maxPrice);
        var count_1 = pin.isCluster ? pin.value.reduce(function (acc, it) { return acc + it.count; }, 0) : pin.value.count;
        var renderCount = function () { return count_1 > 1 ? (React.createElement("span", { className: "c-maplabel--count" }, count_1)) : null; };
        return (React.createElement("div", { className: clusterClass_2, style: { cursor: 'pointer' } },
            React.createElement("div", { onClick: onClick, className: "c-maplabel__body" },
                title,
                renderCount()),
            pin.popupActive ? renderPopup() : null));
    }
    var clusterClass = classnames_1.default('c-mapcluster', 'c-mapcluster--nooffset', 'c-mapcluster--dot', {
        'c-mapcluster--dark': pin.count > 1 && pin.count <= 5,
        'c-mapcluster--darker': pin.count > 5,
        'c-mapcluster--bg': pin.unfocus,
    });
    return (React.createElement("div", { onClick: onClick, className: clusterClass, style: { cursor: 'pointer ' } }, pin.popupActive ? renderPopup() : null));
}; };
